import { render } from "./ResultChallengeSelectUserUsername.vue?vue&type=template&id=96f2ff74&scoped=true"
import script from "./ResultChallengeSelectUserUsername.vue?vue&type=script&lang=js"
export * from "./ResultChallengeSelectUserUsername.vue?vue&type=script&lang=js"

import "@/css/components/result-challenge-select-user-username.css?vue&type=style&index=0&id=96f2ff74&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f2ff74"]])

export default __exports__